export const TENANT_CREATION_DIALOG = {
  NAME: 'Tenant Name',
  STANDARD: 'Tenant Standards',
  DESCRIPTION: 'Description',
  CREATE: 'Create',
  ERROR_CREATING_TENANT: 'Error creating tenant',
  TENANT_CREATED_SUCCESSFULLY: 'Tenant created successfully',
}

export const TENANTS = {
  TITLE: 'Tenants',
  SORT: {
    RISK_HIGH: 'Highest Risk',
    RISK_LOW: 'Lowest Risk',
    PROGRESS_HIGH: 'Most Progress',
    PROGRESS_LOW: 'Least Progress',
  },
  RISK_CHART: {
    TITLE: 'Tenant Risk Overview',
    DESCRIPTION: 'Risk scores across your tenant portfolio',
    LOW_RISK: 'LOW RISK',
    MEDIUM_RISK: 'MEDIUM RISK',
    HIGH_RISK: 'HIGH RISK',
    RISK_LABEL: 'Risk',
    RISK_ZONE_LOW: 'Low Risk',
    RISK_ZONE_MEDIUM: 'Medium Risk',
    RISK_ZONE_HIGH: 'High Risk',
  },
  RISK_SUMMARY: {
    TITLE: 'Risk Summary',
    GLOBAL_RISK: 'Global Risk',
    COMPLIANCE_STANDARDS: 'Compliance Standards',
    OVERALL: 'Overall',
  },
  TENANT_ITEM: {
    RISK: 'Risk',
    NO_STANDARDS: 'No standards configured',
    CERTIFICATION: 'certification',
    CERTIFICATIONS: 'certifications',
  },
  SNACKBAR: {
    ERROR_SWITCHING: 'Error switching tenant',
    SWITCHED: 'Tenant switched',
  },
  NAV_USER: {
    TENANT: 'Tenant',
    SIMULATED_TENANT: 'Simulated Tenant',
    SWITCH_TENANT: 'Switch Tenant',
    LOG_OUT: 'Log out',
    LAST_LOGIN: 'Last login',
  },
  COMMAND_SEARCH: {
    TITLE: 'Command Palette',
    PLACEHOLDER: 'Type a command or search...',
    NO_RESULTS: 'No results found.',
    DESCRIPTION: 'Search and execute commands',
    NAVIGATION: 'Go to',
  },
}
